import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 4",
  "description": "",
  "published": "2007-09-23T00:00:00.000Z",
  "redirect_from": ["/blog/london-4/swizec/152"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Haven't posted in a few days due to a minor case of writer's block. It happens, can't predict it, can't prevent it and it might've had something to do with yesterday's equinox.`}</p>
    <p>{`So about what I'm going to post tonight, it's a bit scary and perhaps a bit daunting, maybe with a flare of sparkling funny and almost certainly without any great merit. It is to be about food. So far I've only had a few brushes with english cuisine and they were all quite marvelous.`}</p>
    <p>{`Pub food is probably the cheapest per amount of food you can get around here. The meals are bloody huge and whatever you order you have to remember that you'll get a bunch of chips to go along with it. Similar to how you get a huge fucking bowl of rice with anything chinese you order anywhere. Another brush with destiny was fish and chips, which I find to be too glorified. We've been eating such stuff at home since I can remember and it isn't anything too english.`}</p>
    <p>{`The service, however, anywhere in London, save for the priciest of locations of course, is rather interestingly spun to what I'm used to. Everywhere they make you go up to the bar, order, pay and get your stuff; with food you sometimes wait for a bit and get it served to your table. But in general they make you take your own stuff to the table, much like fast food places and clubs. It's somewhat disapointing, but oh so London.`}</p>
    <p>{`I am appaled, however, that there is no bloody cafe in this town, that I could find, that can serve tea as tea is supposed to be served. And this is supposed to be a bloody tea country.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      